import { ArrayElement } from "../utilities/ArrayElement";

export const supportedLocaleValues = ["de", "en-de", "en-us", "en-gb"] as const;
export type SupportedLocale = ArrayElement<typeof supportedLocaleValues>;
